<template>
    <div>
        <b-form-group
            :label="labelByInstance"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': this.field.key =='pepDeclaration.other'? requiredFields:this.field.isRequired
            }"
        >
            <b-form-textarea
                id="textarea"
                v-model="model"
                v-validate="{
                    required:  this.field.key =='pepDeclaration.other'? requiredFields:this.field.isRequired,
                }"
                :placeholder="field.placeholder"
                rows="3"
                max-rows="3"
                :disabled="loading || isDisabled"
                :data-vv-name="labelByInstance"
                :class="{
                    'is-invalid': errors.has(labelByInstance),
                    'is-invalid': isInvalid,
                }"
            ></b-form-textarea>
        </b-form-group>
    </div>
</template>

<script>
import TextField from './TextField'
import {mapGetters} from 'vuex'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: TextField,
    data() {
        return {
            isInvalid: false,
            isRequired:false,
            isDisabled:false,
            fieldsToCheck:[
                {
                    field:'crsInfo.otherReason1',
                    dependency:'crsInfo.reason1'
                },
                {
                    field:'crsInfo.otherReason2',
                    dependency:'crsInfo.reason2'
                },
                {
                    field:'crsInfo.otherReason3',
                    dependency:'crsInfo.reason3'
                },
                {
                    field:'accountInfo.strReason',
                    dependency:'accountInfo.isStr'
                },
                {
                    field:'accountInfo.enhancedDueDiligence.scrutinyRemarks',
                    dependency:'accountInfo.enhancedDueDiligence.isScrutinyPerformed'
                },
                {
                    field:'accountInfo.enhancedDueDiligence.custBusInquiredRemarks',
                    dependency:'accountInfo.enhancedDueDiligence.isCustBusInquired'
                },
                {
                    field:'accountInfo.enhancedDueDiligence.managementApprovalRemarks',
                    dependency:'accountInfo.enhancedDueDiligence.isManagementApproval'
                },
                {
                    field:'accountInfo.enhancedDueDiligence.firstPaymentRemarks',
                    dependency:'accountInfo.enhancedDueDiligence.isFirstPayment'
                },
            ],
        }
    }, // End of Component > extends
    
    computed:{
        ...mapGetters(['form','updateField']),
        requiredFields(){
            return this.isRequired
        },
        labelByInstance() {
            // field.label
            if(this.$route.path.includes('company') || this.$store.getters.form.type=='company')
            {
                if (this.field.key == 'sourceOfFunds.OtherEvidenced') {
                    return 'Enter details of Company\'s Source of Funds'
                }
                else
                {
                    return this.field.label
                }

            }
            else
            {
                return this.field.label
            }

        },
    },

    mounted() {
        if (this.field.key == 'sourceOfWealth.OtherEvidenced') {
            if (this.$store.state.registration.form.sourceOfWealth.evidenced) {
                const newValue =
                    this.$store.state.registration.form.sourceOfWealth.evidenced
                if (newValue && newValue.length && newValue.length > 0) {
                    let index = -1
                    index = newValue.findIndex((e) => {
                        if (e == 'Other') {
                            return true
                        }
                    })
                    if (index != -1) {
                        this.field.isRequired = true,
                        this.isRequired = true
                    } else {
                        this.field.isRequired = false
                        this.isRequired = false
                    }
                }
            }
        }
        if (this.field.key == 'sourceOfFunds.OtherEvidenced') {
            if (this.$store.state.registration.form.sourceOfFunds.evidenced) {
                const newValue =
                    this.$store.state.registration.form.sourceOfFunds.evidenced
                if (newValue && newValue.length && newValue.length > 0) {
                    let index = -1
                    index = newValue.findIndex((e) => {
                        if (e == 'Other') {
                            return true
                        }
                    })
                    if (index != -1) {
                        this.field.isRequired = true
                        this.isRequired = true
                    } else {
                        this.field.isRequired = false
                        this.isRequired = false
                    }
                }
            }
        }

        const fieldFound = this.fieldsToCheck.find(fieldObj => fieldObj.field === this.field.key);
        if(fieldFound)
        {
            let fieldName = fieldFound.dependency.split('.')
            let condition = this.$store.state.registration.form[fieldName[0]][fieldName[1]]=='Unable to obtain a TIN/Equivalent Number'

            if(fieldName[0]=='accountInfo')
            {
                condition=this.customToLowerCase(this.$store.state.registration.form[fieldName[0]][fieldName[1]])=='yes' || 
                          ( fieldName.length == 3 && this.customToLowerCase(this.form[fieldName[0]][fieldName[1]][fieldName[2]]) == "yes")
            }
            if(condition)
            {
                this.isDisabled = false//!this.isDisabled
                fieldName.includes('enhancedDueDiligence') ? this.field.isRequired = false : this.field.isRequired = true
            }
            else
            {
                this.isDisabled = true//!this.isDisabled
                this.field.isRequired = false
            }
        }
    },

    created() {
        if (this.field.key == 'pepDeclaration.other') {
            // console.log(this.$store.state.registration.form.pepInfo)
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.pepDeclaration
                },
                (newValue, oldValue) => {
                    // console.log(newValue)
                    for (let key in newValue) {
                        if (newValue.hasOwnProperty(key)) {
                            // console.log(key + ' -> ' + newValue[key])
                            if (newValue[key] == 'Yes') {
                                this.field.isRequired = true
                                this.isRequired = true
                                // this.isInvalid = true
                                break
                            } else {
                                this.field.isRequired = false
                                this.isRequired = false
                                // this.isInvalid = false
                            }
                        }
                    }
                    // console.log(this.$store.state.registration.form.pepInfo)
                },
                {
                    deep: true,
                }
            )
        }
        if (this.field.key == 'sourceOfWealth.OtherEvidenced') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.sourceOfWealth
                        .evidenced
                },
                (newValue) => {

                    if (newValue && newValue.length && newValue.length > 0) {
                        let index = -1
                        index = newValue.findIndex((e) => {
                            if (e == 'Other') {
                                return true
                            }
                        })
                        if (index != -1) {
                            this.field.isRequired = true
                            this.isRequired = true
                        } else {
                            this.field.isRequired = false
                            this.isRequired = false
                        }
                    }
                }
            )
        }

        if (this.field.key == 'sourceOfFunds.OtherEvidenced') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.sourceOfFunds
                        .evidenced
                },
                (newValue) => {
                    if (newValue && newValue.length && newValue.length > 0) {
                        let index = -1
                        index = newValue.findIndex((e) => {
                            if (e == 'Other') {
                                return true
                            }
                        })
                        if (index != -1) {
                            this.field.isRequired = true
                            this.isRequired = true
                        } else {
                            this.field.isRequired = false
                            this.isRequired = false
                        }
                    }
                }
            )
        }

        const fieldFound = this.fieldsToCheck.find(fieldObj => fieldObj.field === this.field.key);

        if (fieldFound) {

            this.$store.watch(
                (state) => {
                    let fieldName = fieldFound.dependency.split('.')
                    return fieldName.length == 3 ? this.form[fieldName[0]][fieldName[1]][fieldName[2]] : this.form[fieldName[0]][fieldName[1]]// could also put a Getter here

                },
                (newValue, oldValue) => {
                    let fieldName = fieldFound.dependency.split('.')
                    let condition = newValue=='Unable to obtain a TIN/Equivalent Number'
                    if(fieldName[0]=='accountInfo')
                    {
                        condition=this.customToLowerCase(newValue)=='yes'
                    }
                    if(condition){
                    // if (newValue == 'Unable to obtain a TIN/Equivalent Number') {

                        this.isDisabled = false//!this.isDisabled
                        fieldName.includes('enhancedDueDiligence') ? this.field.isRequired = false : this.field.isRequired = true

                    } else {
                        this.model=''
                        this.isDisabled = true//!this.isDisabled
                        this.field.isRequired = false
                    }
                }
            )
        }
    },
    methods: {
        customToLowerCase(value){
            return typeof value == 'string' ? value.toLowerCase() : ''
        }
    }, // End of Component > mounted
}
</script>
